import { TableComponents, ColumnProps } from 'antd/lib/table';
import EditableCell, { EditableFormRow } from './EditableCell';

export interface IEditColumnProps<T> extends ColumnProps<T> {
  editable?: boolean;
}

export const EditableComponents: TableComponents = {
  body: {
    row: EditableFormRow,
    cell: EditableCell,
  },
};



// WEBPACK FOOTER //
// ./src/components/common/Editable.tsx